import { DataTransform } from 'src/app/domainObjects/dataTransform';
import { ExtractorStartRuleType, ExtractorEndRuleType } from '../messaging/engine';
import { TransformRule } from './transformRule';
import { TransformType } from './transformType';
import { DataFarmType } from './dataFarmType';
import { SortInfo } from './sortInfo';
import { ColoredTextFindReplaceItem, ColoredTextItem } from './coloredTextItem';

export class RowExtractorTransform extends DataTransform<RowExtractorTransformConfig> {
    
    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.rowExtractor,nodeID);
      this.transformConfig = new RowExtractorTransformConfig();
    }

    static fromJSON(data: any): RowExtractorTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: RowExtractorTransform = Object.assign(new RowExtractorTransform(0, 0, '',''), data);
        instance.transformConfig = RowExtractorTransformConfig.fromJSON(instance.transformConfig);
        instance.compiledAt = instance.compiledAt ? new Date(instance.compiledAt) : null;

        return instance;
    }

    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class RowExtractorTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    defSourceField: string;
    defTargetField: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    groupBy: string;
    userField : string;
    timestampField: string;
    missesNamed: string;
    //delMisses :boolean;
    sampleStart: number;
    sampleEnd: number;
    minLength: number;
    maxLength: number;
    runAll :boolean;
    bufferRows: number;
    threads: number;
    //multiColumnTarget:boolean;
    resetRows:boolean;
    searchWildCard: string;
    defMaxLength: number;
    defMinLength: number;
    defMaxSearch: number;

    addFields: string[];
    rules: RowExtractorTransformRule[];
    defTimeout : number;

    rowMissesOption:RowMissesOptionExtractor;
    sequenceOption:SequenceOption;
    consolidation:ConsolidationLevel;
    smartSampleMode: SmartSampleMode;
    spaceSeparator :boolean;
    removeRedundant :boolean;
    orderField: string;
    isOpenField: string;
    isCloseField: string;

    static fromJSON(data: any): RowExtractorTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: RowExtractorTransformConfig = Object.assign(new RowExtractorTransformConfig(), data);

        const rules: RowExtractorTransformRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = RowExtractorTransformRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export class RowExtractorTransformRule extends TransformRule {
    sourceField: string;
    targetField: string;
    startRule: ExtractorStartRuleType;
    startString: string;
    startChars = 0;
    endRule: ExtractorEndRuleType;
    endString: string;
    endCharsLen = 0;
    maxSearch : number;
    minLength : number;
    maxLength : number;
    //resultFind: string;
    //resultReplace: string;
    ignoreSpaces = true;
    matchCase = false;
    matchAll = false;
    findReplace?: FindReplace;

    static fromJSON(data: any): RowExtractorTransformRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: RowExtractorTransformRule = Object.assign(new RowExtractorTransformRule(), data);

        return instance;
    }
}

export interface RowExtractorRuleStats {
    rowHits: number;
    ruleIndex: number;
    groupHits: number;
}

export interface GlobalStats {
    rowHits: number;
    hitRate?: number;
    rowMisses?: number;
    groupHits?: number;
}

export interface RowExtractorPreviewStats {
    globalStat: GlobalStats;
    ruleStats?: RowExtractorRuleStats[];
}

export interface FindReplace {
    [key: string]: string;
}

export enum SmartSampleMode {
    per_field = 0,
    combined  = 1,
}

export class SmartSampleModeUtil {
    static toString(val: SmartSampleMode): string {
        switch (val) {
            case SmartSampleMode.per_field: return 'Per-field';
            case SmartSampleMode.combined:  return 'Combined';
        }
    }
}

export enum SequenceOption {
    base = 0,
    multiTarget = 1,
    recursive = 2
}

export enum ConsolidationLevel {
    off      = 0,
    detailed = 1,
    low      = 2,
    standard = 3,
    high     = 4,
    compact  = 5
}

export class ConsolidationLevelUtil {
    static toString(val: ConsolidationLevel): string {
        switch (val) {
            case ConsolidationLevel.off:      return 'Off';
            case ConsolidationLevel.detailed: return 'Detailed';
            case ConsolidationLevel.low:      return 'Low';
            case ConsolidationLevel.standard: return 'Standard';
            case ConsolidationLevel.high:     return 'High';
            case ConsolidationLevel.compact:  return 'Compact';
        }
    }
}

export class SequenceOptionUtil {
    static toString(val: SequenceOption): string {
        switch (val) {
            case SequenceOption.base:
                return 'Progressive';
            case SequenceOption.multiTarget:
                return 'Multi-Target';
            case SequenceOption.recursive:
                return 'Recursive';
        }
    }
}

export enum RowMissesOptionExtractor {
    keeptarget = 0,
    keepsource = 1,
    delete = 2,
    empty = 3,
    named = 4
}

export class RowMissesOptionExtractorUtil {
    static toString(val: RowMissesOptionExtractor): string {
        switch (val) {
            case RowMissesOptionExtractor.keeptarget:
                return 'Keep Target';
            case RowMissesOptionExtractor.keepsource:
                return 'Keep Source';
            case RowMissesOptionExtractor.delete:
                return 'Delete';
            case RowMissesOptionExtractor.empty:
                return 'Empty';
            case RowMissesOptionExtractor.named:
                return 'Named';
        }
    }
}
